import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const ConditionalRoot: React.FC = () => {
  const location = useLocation();
  
  // Check if there are query parameters (specifically formId or topicId)
  const searchParams = new URLSearchParams(location.search);
  const hasFormId = searchParams.has('formId');
  const hasTopicId = searchParams.has('topicId');
  
  // If survey-related query params exist, redirect to /surveyForm with params
  if (hasFormId || hasTopicId) {
    return <Navigate to={`/surveyForm${location.search}`} replace />;
  }
  
  // Otherwise, redirect to dashboard
  return <Navigate to="/dashboard" replace />;
};